import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user.js';
import editor from './modules/editor.js';
import ai from './modules/ai.js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  getters: {
    miniEnv: state => state.user.miniEnv,
    appId: state => state.user.appId,
    exhibitionId: state => state.user.exhibitionId,
    languageType: state => state.user.languageType,
    subjectType: state => state.user.subjectType,
    terminal: state => state.user.terminal,
    tenantId: state => state.ai.tenantId,
    bot_id: state => state.ai.bot_id,
    user_id: state => state.ai.user_id,
    ai_token: state => state.ai.ai_token,
    public_token: state => state.ai.public_token,
    pathParams: state => state.ai.pathParams,
    lang: state => state.ai.lang,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    editor,
    ai
  },
});
